function fallbackCopyTextToClipboard(text)
{
    var textArea = document.createElement("textarea")
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = "0"
    textArea.style.left = "0"
    textArea.style.position = "fixed"

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    var success
    try {
        success = document.execCommand('copy')
    } catch (err) {
        success = false
    }
    document.body.removeChild(textArea)
    return success
}

function copyTextToClipboard(text)
{
    if (!navigator.clipboard) {
        return new Promise((success, failure) => {
            if (fallbackCopyTextToClipboard(text)) {
                success(true)
            } else {
                failure("Cannot copy to clipboard")
            }
        })
    }
    return navigator.clipboard.writeText(text)
}

export {copyTextToClipboard}
